import React from "react"
import { IconButton } from "@mui/material"

import * as S from "./custom-arrows.styles"

const CustomArrows = (
  { className, leftArrow, rightArrow, slider, number, length },
  props,
) => {
  const gotoNext = () => {
    slider?.current?.slickNext()
  }

  const gotoPrev = () => {
    slider?.current?.slickPrev()
  }
  return (
    <S.ArrowsContainer className={className ?? ""} {...props}>
      <IconButton disableRipple className={leftArrow} onClick={gotoPrev}>
        <S.LeftArrow />
      </IconButton>
      {(number || length) && (
        <S.Number>
          {number + 1}/{length}
        </S.Number>
      )}
      <IconButton disableRipple className={rightArrow} onClick={gotoNext}>
        <S.RightArrow />
      </IconButton>
    </S.ArrowsContainer>
  )
}

export default CustomArrows
